import { getCloudId } from '@helpcenter/meta';

const STUDIO_URL = 'https://studio.atlassian.com';
const STUDIO_URL_STAGING = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';

const isStaging = (): boolean => {
    const host = window.location.host;
    return (
        host.includes('localhost') ||
        host.includes('.stg.atlassian') ||
        host.includes('.stg-east.frontend.public.atl-paas.net') ||
        host.includes('jira-dev.com')
    );
};

export const getStudioEditorUrl = (helpCenterId: string, pageId?: string | null) => {
    const cloudId = getCloudId();
    const studioUrl = isStaging() ? STUDIO_URL_STAGING : STUDIO_URL;
    if (!pageId) {
        return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}`;
    }
    return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}/pages/${pageId}`;
};
